import firebase from "firebase/app";
import "firebase/functions";

export type TapCoinEventStatus = "upcoming" | "open" | "closed";
export type TapCoinPlayStatus =
  | "available"
  | "started"
  | "forfeited"
  | "completed";

export interface TapCoinStatusResponse {
  eventId: string;
  eventStatus: TapCoinEventStatus;
  playStatus: TapCoinPlayStatus;
  eventStartAtMs: number;
  eventEndAtMs: number;
  countdownMs: number;
  durationMs: number;
  minDeposit: number;
  totalDeposit: number;
  depositEligible: boolean;
  balance: number;
  reward: number;
}

export interface TapCoinRoundResponse {
  eventId: string;
  roundToken: string;
  serverNowMs: number;
  playStartsAtMs: number;
  playEndsAtMs: number;
  finishDeadlineAtMs: number;
  countdownMs: number;
  durationMs: number;
}

export interface TapCoinResultResponse {
  success: boolean;
  reward: number;
  tapCount: number;
  balance: number;
  alreadyCompleted: boolean;
}

function tapCoinFunctions() {
  return firebase.app().functions("asia-east2");
}

export async function getTapCoinStatus(
  accessToken: string
): Promise<TapCoinStatusResponse> {
  const callable = tapCoinFunctions().httpsCallable("getTapCoinStatus");
  const result = await callable({ accessToken });
  return result.data as TapCoinStatusResponse;
}

export async function startTapCoinRound(
  accessToken: string
): Promise<TapCoinRoundResponse> {
  const callable = tapCoinFunctions().httpsCallable("startTapCoinRound");
  const result = await callable({ accessToken });
  return result.data as TapCoinRoundResponse;
}

export async function finishTapCoinRound(
  accessToken: string,
  roundToken: string,
  tapOffsetsMs: number[]
): Promise<TapCoinResultResponse> {
  const callable = tapCoinFunctions().httpsCallable("finishTapCoinRound");
  const result = await callable({ accessToken, roundToken, tapOffsetsMs });
  return result.data as TapCoinResultResponse;
}
